import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import CloseIcon from '../../svg/icon/CloseIcon'
import Button from '../Button/Button'
import style from './CloseButton.style'

type CloseButtonProps = {
  className?: string
  variant: 'dark-on-light' | 'light-on-dark'
} & ComponentProps<'button'>

function CloseButton(props: CloseButtonProps): ReactElement {
  const { className = '', variant, ...rest } = props

  return (
    <Button
      className={cn('CloseButton', variant, className)}
      css={style}
      variant="no-shell"
      dropShadow={false}
      {...rest}
    >
      <CloseIcon aria-label="Close" />
    </Button>
  )
}

export default CloseButton
